/* eslint-disable array-bracket-spacing, camelcase */
import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { formatNumberToFixedPdf as formatNumberToFixed } from 'utils';
import i18n from 'utils/i18n';
import { PdfBlockHeading } from '../PdfBlockHeading';

import styles from './styles';

const PdfTotalInfo = ({
	quantity,
	m2,
	linearMeter,
	kg,
	materialCosts,
	shippingCosts,
	subtotal,
	vatCosts,
	total,
	allPricesAvailable,
	showPrice,
	priceVolumeCat,
	configuratorDataPricing,
}) => {
	const { t } = useTranslation('configurationTableHeading');

	const { vat_percent, construction_site_delivery_price_from } = configuratorDataPricing;
	const showPrices = showPrice && allPricesAvailable;
	const showIfPriceEnabled = text => (showPrice ? text : ' ');
	const showFixedIfPriceEnabled = (...args) => (showPrices ? formatNumberToFixed(...args) : ' ');
	const style_col8 = showPrices ? styles.col8 : styles.col8Wide;
	const style_col9 = showPrices ? [styles.col9, styles.cell] : [styles.col9Hidden];
	return (
		<View>
			<PdfBlockHeading title={t('totalCart')} iconName="equals" />
			<View style={styles.totalInfoTable}>
				<View style={styles.row}>
					{/* Row 0: ... matLbl, matCosts */}
					<View style={[styles.col1, styles.cell]} />
					<View style={[styles.col2, styles.cell]} />
					<View style={[styles.col3, styles.cell]} />
					<View style={[styles.col4, styles.cell]} />
					<View style={[styles.col5, styles.cell]} />
					<View style={[styles.col6, styles.cell]} />
					<View style={[styles.col7, styles.cell]}>
						<Text>{showIfPriceEnabled(t('subtotal'))}</Text>
					</View>
					<View style={[style_col8, styles.cell, styles.numericCell]}>
						<Text style={styles.numericText}>
							{showFixedIfPriceEnabled(materialCosts, 2, t('i18n:numberFormat'))}
						</Text>
					</View>
					<View style={[...style_col9]} />
				</View>

				<View style={styles.row}>
					{/* Row 1: ... subtotal_lbl subtotal */}
					<View style={[styles.col1, styles.cell]} />
					<View style={[styles.col2, styles.cell]} />
					<View style={[styles.col3, styles.cell]} />
					<View style={[styles.col4, styles.cell]} />
					<View style={[styles.col5, styles.cell]} />
					<View style={[styles.col6, styles.cell]} />
					<View style={[styles.col7, styles.cell]}>
						<Text>{showIfPriceEnabled(t('lsva'))}</Text>
					</View>
					<View style={[style_col8, styles.cell, styles.numericCell]}>
						<Text style={styles.numericText}>
							{showFixedIfPriceEnabled(shippingCosts, 2, t('i18n:numberFormat'))}
						</Text>
					</View>
					<View style={[...style_col9]} />
				</View>

				<View style={styles.row}>
					{/* Row 2: total_txt empty empty empty empty subtotal_lbl subtotal */}
					<View
						style={[
							styles.col1,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkBottomMargin,
							styles.total_txt,
							styles.total_txtTop,
						]}
					/>
					<View
						style={[
							styles.col2,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkBottomMargin,
							styles.empty,
						]}
					/>
					<View
						style={[
							styles.col3,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkBottomMargin,
							styles.empty,
						]}
					/>
					<View
						style={[
							styles.col4,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkBottomMargin,
							styles.empty,
						]}
					/>
					<View
						style={[
							styles.col5,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkBottomMargin,
							styles.empty,
						]}
					/>
					<View
						style={[
							styles.col6,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkBottomMargin,
							styles.empty,
						]}
					/>
					<View
						style={[
							styles.col7,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkBottomMargin,
							styles.subtotal_lbl,
						]}
					>
						<Text>{showIfPriceEnabled(t('subtotal'))}</Text>
					</View>
					<View
						style={[
							style_col8,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkBottomMargin,
							styles.numericCell,
							styles.subtotal,
						]}
					>
						<Text style={styles.numericText}>
							{showFixedIfPriceEnabled(subtotal, 2, t('i18n:numberFormat'))}
						</Text>
					</View>
					<View style={[...style_col9, styles.greyGridCell, styles.shrinkBottomMargin]} />
				</View>

				<View style={styles.row}>
					{/* Row 3: total_txt qty qty_unit m2 m2_unit vat_lbl vatCosts */}
					<View style={[styles.col1, styles.cell, styles.col1, styles.total_txt]}>
						<Text>{t('blocktotal')}</Text>
					</View>
					<View
						style={[
							styles.col2,
							styles.cell,
							styles.greyGridCell,
							styles.greyGridCell,
							styles.empty,
						]}
					/>
					<View style={[styles.col3, styles.cell, styles.greyGridCell, styles.numericCell]}>
						<Text style={styles.numericText}>{quantity}</Text>
					</View>
					<View style={[styles.col4, styles.cell, styles.greyGridCell, styles.qty_unit]}>
						<Text>{t('pc')}</Text>
					</View>
					<View style={[styles.col5, styles.cell, styles.greyGridCell, styles.numericCell]}>
						<Text style={styles.numericText}>
							{formatNumberToFixed(m2, 2, t('i18n:numberFormat'))}
						</Text>
					</View>
					<View style={[styles.col6, styles.cell, styles.greyGridCell, styles.m2_unit]}>
						<Text>m²</Text>
					</View>
					<View style={[styles.col7, styles.cell, styles.greyGridCell, styles.vat_lbl]}>
						{/* eslint-disable-next-line react/jsx-one-expression-per-line */}
						<Text>
							{showIfPriceEnabled(
								`${t('vat')} (${formatNumberToFixed(vat_percent, 2, t('i18n:numberFormat'))}%)`
							)}
						</Text>
					</View>
					<View style={[style_col8, styles.cell, styles.greyGridCell, styles.numericCell]}>
						<Text style={styles.numericText}>
							{showFixedIfPriceEnabled(vatCosts, 2, t('i18n:numberFormat'))}
						</Text>
					</View>
					<View style={[...style_col9, styles.greyGridCell]} />
				</View>

				<View style={styles.row}>
					{/* Row 4: total_txt kg kg_unit lfm lfm_unit total_lbl total */}
					<View
						style={[
							styles.col1,
							styles.cell,
							styles.shrinkTopMargin,
							styles.total_txt,
							styles.total_txtBottom,
						]}
					/>
					<View
						style={[
							styles.col2,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkTopMargin,
							styles.empty,
						]}
					/>
					<View
						style={[
							styles.col3,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkTopMargin,
							styles.numericCell,
						]}
					>
						<Text style={styles.numericText}>
							{formatNumberToFixed(kg, 0, t('i18n:numberFormat'))}
						</Text>
					</View>
					<View
						style={[
							styles.col4,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkTopMargin,
							styles.kg_unit,
						]}
					>
						<Text>{t('kg')}</Text>
					</View>
					<View
						style={[
							styles.col5,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkTopMargin,
							styles.numericCell,
							styles.lfm,
						]}
					>
						<Text style={styles.numericText}>
							{formatNumberToFixed(linearMeter, 2, t('i18n:numberFormat'))}
						</Text>
					</View>
					<View
						style={[
							styles.col6,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkTopMargin,
							styles.lfm_unit,
						]}
					>
						<Text>{t('linearMeterAbbrev')}</Text>
					</View>
					<View
						style={[
							styles.col7,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkTopMargin,
							styles.total_lbl,
						]}
					>
						<Text>{showIfPriceEnabled(t('totalPriceChf'))}</Text>
					</View>
					<View
						style={[
							style_col8,
							styles.cell,
							styles.greyGridCell,
							styles.shrinkTopMargin,
							styles.numericCell,
							styles.total,
						]}
					>
						<Text style={styles.numericText}>
							{showPrices
								? formatNumberToFixed(total, 2, t('i18n:numberFormat'))
								: allPricesAvailable
									? t('commonConfigurationAction:loginForPriceInfoBox')
									: t('commonConfigurationAction:priceOnDemand')}
						</Text>
					</View>
					<View style={[...style_col9, styles.greyGridCell, styles.shrinkTopMargin]} />
				</View>
			</View>
			<View style={styles.totalInfoMsg}>
				<Text style={styles.totalInfoVolumeDiscount}>
					{priceVolumeCat !== '0' &&
						showPrices &&
						t('volumeDiscountFmt').replace('{}', priceVolumeCat)}
				</Text>
				{m2 >= configuratorDataPricing?.extra_text_from_volume?.volume_from && (
					<Text style={styles.totalInfoExtraTextFromVolume}>
						{configuratorDataPricing.extra_text_from_volume[`text_${i18n.language}`]}
					</Text>
				)}
				<Text style={styles.totalInfoDelivery}>
					{t('constructionSiteDeliveryFmt').replace('{}', construction_site_delivery_price_from)}
				</Text>
			</View>
		</View>
	);
};

export default PdfTotalInfo;
